import { UserAvatarBaseCustomElement } from 'General/Resources/Elements/UserAvatar/UserAvatarBase';
import { Aurelia, autoinject, customElement } from 'aurelia-framework';

@autoinject
@customElement('user-avatar')
export class UserAvatarCustomElement extends UserAvatarBaseCustomElement {

}